import React, { useEffect, useState } from "react";
import { ProgressIndicator } from "@amzn/aws-euc-ui";
import "./style.css";
import { useGetBrandLogo } from "@hooks/customBranding/useGetBrandLogo";
import { CustomColorThemeDiv } from "@components/general/CustomColorTheme/CustomColorTheme";

/** 
 Checking the "SessionStartedResponseTime" Metrics the start-time is about 35 seconds. 
 Adding 5 seconds more as a buffer.
 
 Metrics:
 us-west-2 : https://tiny.amazon.com/16p2jtakg/IsenLink
 us-east-1 : https://tiny.amazon.com/ic5pnoo0/IsenLink
 ap-south-1 : https://tiny.amazon.com/tjyq4lyc/IsenLink
*/
const SESSION_START_TIME = 40000;

const useSpinnerProgress = (time = 0) => {
    const [progress, setProgress] = useState(1);

    useEffect(() => {
        const interval = setInterval(() => {
            setProgress((prevNumber) => {
                if (prevNumber === 100) {
                    clearInterval(interval);
                    return prevNumber;
                }
                return prevNumber + 1;
            });
        }, time / 100);

        return () => clearInterval(interval);
    }, []);

    return progress;
};

interface LoaderProps {
    message: string;
    isDeterminate?: boolean;
}

export const Loader = ({ message, isDeterminate }: LoaderProps) => {
    const progress = useSpinnerProgress(SESSION_START_TIME);
    const isDeterminateProgressBar = isDeterminate && progress < 100;

    const wsbBrandedLogo = useGetBrandLogo("desktop");
    return (
        <CustomColorThemeDiv
            additionalClassNames={[
                "euc-loader-container-style",
                "euc-body-background-style",
                "On-top",
            ]}
        >
            <ProgressIndicator
                header={
                    <div className="euc-loader-header-container">
                        <img
                            className="euc-loader-header-image"
                            src={wsbBrandedLogo}
                        />
                    </div>
                }
                indicatorStyle={{
                    width: "260px",
                }}
                determinate={isDeterminateProgressBar}
                progress={progress}
                size="cover"
                footer={
                    <div className="euc-loader-footer-container">
                        {message && (
                            <span className="euc-loader-footer-span loading-message">
                                {message}
                            </span>
                        )}
                    </div>
                }
            />
        </CustomColorThemeDiv>
    );
};
